function getWeekNumber(dateString) {
  let date = new Date(dateString);
  let year = date.getFullYear();
  let startOfYear = new Date(year, 0, 1);
  let diff = Math.floor((date - startOfYear) / (24 * 60 * 60 * 1000));
  let weekNumber = Math.ceil((diff + startOfYear.getDay() + 1) / 7) + 2;

  return { weekNumber, year };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (!$('.form-check-input#checkbox1').prop('checked')) {
          $(document).find('.upsell_product_variant_id[name="items[1][id]"]').removeAttr('name');
          $(document).find('.upsell_product_qty[name="items[1][quantity]"]').removeAttr('name');
        } else {
          $(document).find('.upsell_product_variant_id').attr('name', 'items[1][id]');
          $(document).find('.upsell_product_qty').attr('name', 'items[1][quantity]');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch('/cart/add', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('items[0][id]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            var getMetafieldOfAddedProduct = $(document).find('product-info .order-now .seller-bottom-title.main-week').data('levertijd');
            var getMetafieldOfAddedProduct_length = $(document).find('product-info .order-now .seller-bottom-title.main-week').length;
            if (getMetafieldOfAddedProduct_length > 0) {
              if (getMetafieldOfAddedProduct != null) {
                var result = getWeekNumber(getMetafieldOfAddedProduct);
                $(".cart-notification-product#cart-notification-product .cart-notification-main-week .week-output").text(`${result.weekNumber}`);
              }
            } else {
              $(document).find(".main-week.cart-notification-main-week").parent('.seller-bottom').css("display", "none !important");
            }
            if (getMetafieldOfAddedProduct_length == 0) {
              $(document).find(".main-week.cart-notification-main-week").parent('.seller-bottom').css("display", "none !important");
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

    }
  );
}

$(document).ready(function () {
  $('select.form-controls.desk-quantity_selector').change(function () {
    var qty = $(this).val();
    $('.product-form.desk-form .product-form_quantity').val(qty);
  });
  $('select.form-controls.mobile-quantity_selector').change(function () {
    var qty = $(this).val();
    $('.product-form.mobile-form .product-form_quantity').val(qty);
  });
  $('select.form-controls.sticky-quantity_selector').change(function () {
    var qty = $(this).val();
    $('.product-form.sticky-form .product-form_quantity').val(qty);
  });
  $('select.form-controls.mobile-sticky-quantity_selector').change(function () {
    var qty = $(this).val();
    $('.product-form.mobile-sticky-form .product-form_quantity').val(qty);
  });
  $('select.form-controls.dit-wordt-quantity_selector').change(function () {
    var qty = $(this).val();
    $('.product-form.dit-wordt-form .product-form_quantity').val(qty);
  });
});